import React from "react";
import { Spinner, Link } from "components/common";
import useReceivedBy from "forwarder/message-details/useReceivedBy";
import ForwarderRoutes from "forwarder/Routes";
const ForwarderReceivedBy = ({ inputId, forwarderNodeId }) => {
  const { forwarder, input, isLoading } = useReceivedBy(inputId, forwarderNodeId);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dt", null, "Received by"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("em", null, input == null ? void 0 : input.title), " on ", /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.details(forwarder == null ? void 0 : forwarder.id) }, forwarder == null ? void 0 : forwarder.title)));
};
export default ForwarderReceivedBy;
